const languageMap = {
    'es': 'es-MX',
    'fr': 'fr-CA'
};

async function prepareEmployerTags(user) {
    const tags = {};

    if (user.entry_mode) {
        tags['data-ft-userHighestLevelBID'] = user.entry_mode.brand_id;
        tags['data-ft-userHighestLevelName'] = user.entry_mode.brand_name;
    }

    if (user.highest_parent) {
        tags['data-ft-highestLevelBID'] = user.highest_parent.id;
        tags['data-ft-highestLevelName'] = user.highest_parent.name;
    }

    if (user.entry_mode?.brand_id) {
        try {
            const userBrandProfile = await ProfileAPI.getBrandProfile(user.entry_mode.brand_id);
            if (userBrandProfile?.Location?.[0]?.formatted_address) {
                tags['data-ft-userHighestLevelAddress'] = userBrandProfile.Location[0].formatted_address;
            }
        }
        catch (e) {
        }
    }

    return tags;
}

async function prepareEmployeeTags(employeeActiveBrand) {
    const tags = {};

    if (employeeActiveBrand) {
        tags['data-ft-userHighestLevelBID'] = employeeActiveBrand.id;
        tags['data-ft-userHighestLevelName'] = employeeActiveBrand.name;

        try {
            const userBrandProfile = await ProfileAPI.getBrandProfile(employeeActiveBrand.id);
            if (userBrandProfile?.Location?.[0]?.formatted_address) {
                tags['data-ft-userHighestLevelAddress'] = userBrandProfile.Location[0].formatted_address;
            }
        }
        catch (e) {
        }
    }

    return tags;
}

async function prepareForethoughtWidgetTags(lang, employeeActiveBrand) {
    const user = await UserAPI.getLoggedInUserInfo();

    const userRole = environmentsConfig.getEnv().host === environmentsConfig.TEAM_SCHEDULE ? 'employee' : user.user_employer ? 'employer' : 'applicant';

    let tags = {
        'id': "forethought-widget-embed-script",
        'data-api-key': environmentsConfig.get('ForethoughtAPIKey'),
        'emit-tracking-events': true,
        'data-ft-Full-Name': `${user.first_name} ${user.last_name}`,
        'data-ft-userRole': userRole,
        'data-ft-harriPage': window.location.href,
        'data-ft-Embed-Script-Language': languageMap[lang] || lang,
    }

    if (user.email) {
        tags['data-ft-Email'] = user.email;
    }

    if (userRole === 'employer') {
        const employerTags = await prepareEmployerTags(user);
        tags = {...tags, ...employerTags};
    } else if (userRole === 'employee') {
        const employeeTags = await prepareEmployeeTags(employeeActiveBrand);
        tags = {...tags, ...employeeTags};
    }

    return tags;
}

export async function openForethoughtAIChatbot(lang, employeeActiveBrand) {
    const tags = await prepareForethoughtWidgetTags(lang, employeeActiveBrand);
    return Utils.loadScript({
        url: 'https://solve-widget.forethought.ai/embed.js',
        tagAttributes: tags
    })
        .then(() => {
            Forethought?.("widget", "show")
            Forethought?.("widget", "open")
            window?.addEventListener('message', (event) => {
                if (event.data.event === 'forethoughtWidgetLoaded') {
                    Forethought?.("widget", "open")
                }

                if (event.data.event === 'forethoughtWidgetClosed') {
                    Forethought?.("widget", "hide")
                }
            });
        })
        .catch(error => {
            console.error('Error loading Forethought widget:', error);
        });
}
